// This file is populated on runtime once deployed based on the tenant release
export const environment = {
  production: true,
  config: {
    url: '#{apiUrl}#',
    tenant: '#{tenant}#',
  },
};
